import { PhnxImageHolder } from '../ImageHolder/ImageHolder'
import styles from './Ticker.module.css'

export type TickerProps = {
  title: string
  items: {
    title?: string
    asset: {
      src: string
      alt: string
    }
  }[]
}

export const PhnxTicker: React.FC<TickerProps> = ({ title, items }) => {
  return (
    <div className={`container ${styles['ticker']}`}>
      <div className={styles['inner-container']}>
        <div className={styles.title}>{title && <p>{title}</p>}</div>
        <div className={styles.slider}>
          <div className={styles['container']}>
            {items &&
              items.length > 0 &&
              items.map((item, index) => (
                <div className={styles['slide']} key={'set1-' + index}>
                  <PhnxImageHolder images={[item.asset]} />
                </div>
              ))}
          </div>

          <div className={styles['container']}>
            {items &&
              items.length > 0 &&
              items.map((item, index) => (
                <div className={styles['slide']} key={'set2-' + index}>
                  <PhnxImageHolder images={[item.asset]} />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}
